/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { publicCefrV1DataSchema } from '../getPublicCefrV1/public-cefr-v1-data-schema';

export const getPublicCefrV2ResponseSchema = createApiResponseSchema(
  publicCefrV1DataSchema,
) as z.ZodSchema<IAPI<z.infer<typeof publicCefrV1DataSchema>>>;

export type IGetPublicCefrV2Response = IAPI<z.infer<typeof publicCefrV1DataSchema>>;
